import { observable, action } from 'mobx'
import * as defaultConst from '../../constants/default_constants'
import DataManipState from 'react-mobx-admin/state/data_manip'

export default (store) => class EnumEditStore extends DataManipState {
  validators = {
    _global: (entity) => {
      const foundID = entity.has('value') ? entity.get('value') : ''
      const foundDefault = entity.get('transls').find((i) => (i.lang === defaultConst.DEFAULT_LANG))
      if (!foundDefault || foundDefault.value.length === 0 || !foundID) {
        return ['ID & english title are mandatory']
      }
      // Enum ID of the country or group of countries to uppercase and remove spaces
      if (this.editedParent && this.editedParent === 'Countries' && foundID) {
        entity.set('value', entity.get('value').toUpperCase().replace(/\s/g, ''))
      }
    }
  }

  @observable showForm = false
  @observable path = []
  @observable root = {
    children: []
  }

  prepareNew () {
  }

  init (requester, onRequesterError) {
    this.requester = requester
    this.onRequesterError = onRequesterError
    this._loadEnums(this.root)
    store.loadEnumOptions('FilmCargoLanguages')
  }

  onSaved (saved) {
    store.addMessage('successfully saved', 'success', 2000)
    super.onSaved(saved)
  }

  _loadEnums (parent) {
    const parentid = parent.value ? parent.value : ''
    const url = `/enums/options/${encodeURIComponent(parentid)}?lang=en`
    this.requester.call(url)
      .then(action(result => {
        if (result && result.data.length > 0) {
          result.data.map((i) => i.children = [])
          const p = this.path
          if (p.length > 0) {
            p[p.length - 1].children = [] // close path's last node
            p.remove(p[p.length - 1]) // remove last
          }
          if (this.root != parent) {
            p.push(parent)
          }
          parent.children = result.data
        }
      }))
      .catch(this.onRequesterError)
  }

  handleRemove (row) {
    store.removeArrayRow('transls', row)
  }

  handleAdd (lang) {
    store.addArrayRow('transls', { lang, value: '' })
  }

  handleChange (lang, value) {
    store.changeAttrArrayValue('transls', { lang }, value)
  }

  copyLang (entity, tablang) {
    const def = entity.get('transls').find(i => i.lang === defaultConst.DEFAULT_LANG)
    const update = entity.get('transls').find(i => i.lang === tablang)

    if (update && update.lang) {
      update.value = def.value
      update.udated = Date.now()
    } else {
      entity.get('transls').push({ lang: tablang, value: def.value })
    }
    store.addMessage('Copied', 'info')
  }

  @action
  editEnumItem (item) {
    const parentid = item.parent ? item.parent : ''
    this.edited = item
    this.requester.call(`/enums/${encodeURIComponent(item.value)}/${parentid}`)
      .then(this.onEnumLoaded.bind(this))
  }

  @action onEnumLoaded (result) {
    this.adding = false
    this.editedParent = this.edited.parent
    this.showForm = true
    this.record = this.record || new Map()
    this.record.replace({
      value: this.edited.value,
      transls: result.data.map(i => ({ id: i.id, lang: i.lang, value: i.text, created_at: i.created_at }))
    })
    this.runGlobalValidator()
  }

  @action
  addEnumItem (parent = null) {
    this.adding = true
    this.showForm = true
    this.editedParent = parent ? parent.value : null
    this.record = observable.map({
      transls: [{ lang: defaultConst.DEFAULT_LANG, value: '' }]
    })
    this.runGlobalValidator()
  }

  @action
  loadEnums (parent) {
    return this._loadEnums(parent)
  }

  @action
  cancelEdit () {
    if (store && store.router && store.router.queryParams) {
      delete store.router.queryParams._tablang
      delete store.router.queryParams._autoscroll
    }
    this.showForm = false
  }

  @action
  saveEnum () {
    const onOk = action((resp) => {
      this.showForm = false
      this.record = null // resetovat entitu = zavrit modal okno
      this.editedParent && store.markDirty(this.editedParent)
      if (this.editedParent) {
        const found = this.root.children.find(c => c.value === this.editedParent)
        this.openEnumItem = this.editedParent
        this.loadEnums(found)
      } else {
        this.loadEnums(this.root)
      }
      if (store && store.router && store.router.queryParams) {
        delete store.router.queryParams._tablang
        delete store.router.queryParams._autoscroll
      }
      store.addMessage(store.__('enum successfully saved'), 'success', 2000)
    })

    const data = this.record.get('transls').map(i => ({
      id: i.id || null,
      parent: this.editedParent,
      lang: i.lang,
      text: i.value.trim(),
      value: this.record.get('value').trim(),
      created_at: i.created_at || new Date(),
      updated_at: i.created_at ? new Date() : null
    }))

    if (this.adding) {
      this.requester.call('/enums', 'post', data)
        .then(onOk)
        .catch(this.onRequesterError.bind(this))
    } else {
      const parentid = this.editedParent ? this.editedParent : ''
      const url = `/enums/${encodeURIComponent(this.record.get('value'))}/${parentid}`
      this.requester.call(url, 'put', data).then(onOk)
    }
  }
}
